import { useState, useEffect } from "react";
import Button from '@mui/material/Button';
import { backendGetRequest, backendPatchWithoutRefresh } from "../../../helpers/callBackend";
import { useUcs } from "../../../helpers/contexts/UserCompanySettingsContext";
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Unstable_Grid2'
import { errorMessage } from "../../../helpers/errorMessageFunc";

const DetokenizedAccountDetails = ({ bankAccountId, field, label, onSuccess, allowEdit }) => {
    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [newVal, setNewVal] = useState("");
    const [error, setError] = useState("");
    const [isDashboardEditor, setIsDashboardEditor] = useState(false)

    const ucsContext = useUcs()

    useEffect(() => {
      if (ucsContext.loaded) {
        setIsDashboardEditor(ucsContext.isDashboardEditor())
      }
    }, [ucsContext])

    useEffect(() => {
        fetchDetails();
    }, [bankAccountId, field]);
  
    useEffect(() => {
      if (error.length > 0) {
        errorMessage(error)
        setError('')
      }
    }, [error])

    const camelToSnakeCase = (str) => {
        return str.split(/(?=[A-Z])/).join("_").toLowerCase();
    }

    const fetchDetails = async () => {
        if (!bankAccountId ||!field) return;
        try {
            const { data } = await backendGetRequest("/api/bank-account/detokenize/", { params: { bank_account_id: bankAccountId, key: field } });
            const fieldName = camelToSnakeCase(field);
            setValue(data[fieldName] || "");
            setLoading(false);
            if (onSuccess) onSuccess(data);
        } catch (err) {
            console.error(err);
        }
    };

    const validateAndSave = async (val) => {
        if (val.length < 8 ||!/^\d+$/.test(val)) {
            setError(`${label} must be at least 8 digits long and contain only numbers.`);
            return false;
        }
        try {
            setIsEditing(true);
            const fieldName = camelToSnakeCase(field);
            const { data } = await backendPatchWithoutRefresh("/api/bank-account/", { action: fieldName, account_id: bankAccountId, [fieldName]: val });
            if (data) {
                setValue(val);
                setIsEditing(false);
                setNewVal("");
            }
        } catch (err) {
            setError("Save not successful. Try again.");
        }
    };

    const handleSave = () => {
        validateAndSave(newVal);
    };

  const textFieldStyle = {
    fullWidth: true,
    size: 'small',
    InputProps: {
      style: {
        borderRadius: 0,
        maxHeight: '32px',
        maxWidth: '124px',
      },
    },
  }

    const renderField = () => {
        if (!allowEdit || loading || !isDashboardEditor) {
            return <Grid container direction='row' spacing={1} alignItems='center'>
              <Grid item>
                <Typography>{value}</Typography>
              </Grid>
            </Grid>
        }
        if (isEditing) {
            return (
              <Grid container direction='row' spacing={1} alignItems='center'>
                <Grid item>
                  <TextField defaultValue={value} onChange={(e) => setNewVal(e.target.value)} {...textFieldStyle} />
                </Grid>
          <Grid item>
            <Button sx={{ fontSize: 12, textTransform: 'none' }} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary" onClick={handleSave} disabled={!newVal}>Save</Button>
          </Grid>
          <Grid item>
            <Button sx={{ fontSize: 12, textTransform: 'none' }} disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary" onClick={() => setIsEditing(false)}>Cancel</Button>
          </Grid>
              </Grid>
            )
        }
        return (
            <Grid container direction='row' spacing={1} alignItems='center'>
              <Grid item>
            <Typography>{value}</Typography>
          </Grid>
          <Grid item>
  <Button sx={{ fontSize: 12, textTransform: 'none' }} disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary" onClick={() => setIsEditing(true)}>Edit</Button>
          </Grid>
            </Grid>
        );
    };

    return (
      <Grid container direction='row' sx={{ marginBottom: '1em' }} justifyContent='space-between' alignItems='center'>
        <Typography>{label}</Typography>
        <>{renderField()}</>
      </Grid>
    );
};

export default DetokenizedAccountDetails;
